import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditTarifaComponent } from "./edit-tarifa/edit-tarifa.component";

@Component({
  selector: "app-tarifa-v11",
  templateUrl: "./tarifa-v11.component.html",
  styleUrls: ["./tarifa-v11.component.scss"],
})
export class TarifaV11Component extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditTarifaComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
